<template>
  <div>
    <px-view-header title="Minha resposta" :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" link @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loading" class="text-center">
      <px-circular-loading />
    </div>
    <div v-if="!loading && solicitacao">
      <px-cotacao-conjunta-minha-resposta-dados-basicos :solicitacao="solicitacao" />
      <px-cotacao-conjunta-minha-resposta-produtos class="mt-3" :solicitacao="solicitacao" />
    </div>
  </div>
</template>

<script>
import SolicitacaoService from '@/modules/cotacoes/detalhes/solicitacao-service';
import CotacaoConjuntaMinhaRespostaDadosBasicos from './CotacaoConjuntaMinhaRespostaDadosBasicos.vue';
import CotacaoConjuntaMinhaRespostaProdutos from './CotacaoConjuntaMinhaRespostaProdutos.vue';

export default {
  data() {
    return {
      id: this.$route.params.id,
      loading: false,
      solicitacao: null,
      breadcrumbs: [
        { text: 'Negócios' },
        { text: 'Cotações' },
        { text: 'Minha reposta' },
      ],
    };
  },
  methods: {
    onClickBack() {
      this.$router.go(-1);
    },
    getSolicitacao() {
      this.loading = true;
      return SolicitacaoService.getSolicitacao(this.id)
        .then((response) => {
          this.solicitacao = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getSolicitacao();
  },
  components: {
    pxCotacaoConjuntaMinhaRespostaDadosBasicos: CotacaoConjuntaMinhaRespostaDadosBasicos,
    pxCotacaoConjuntaMinhaRespostaProdutos: CotacaoConjuntaMinhaRespostaProdutos,
  },
};
</script>
